<cyno-tabset customClass="tabset tabset--dark">
    <cyno-tab tabTitle="Wel verzekerd" [active]="true">
        <h3>Wel verzekerd</h3>
        <p>Schade door een ongeluk terwijl u:</p>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>Op de motor bent</list-flat-item>
            <list-flat-item>Op de motor stapt of er vanaf</list-flat-item>
            <list-flat-item>Onderweg aan uw motor werkt of u helpt om de motor te repareren</list-flat-item>
        </list-flat>
        <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
    </cyno-tab>
    <cyno-tab tabTitle="Niet verzekerd">
        <h3>Niet verzekerd</h3>
        <p>Schade:</p>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>Aan uw eigen motor/aanhanger/zijspan</list-flat-item>
            <list-flat-item>Aan lading die met de motor vervoerd werd</list-flat-item>
            <list-flat-item>Door een bestuurder die niet met uw motor mocht rijden</list-flat-item>
            <list-flat-item>Tijdens laden/lossen</list-flat-item>
        </list-flat>
        <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
    </cyno-tab>
    <cyno-tab tabTitle="Verzekerde bedragen">
        <h3>Verzekerde bedragen</h3>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>Voor alle personen samen maximaal €&nbsp;50.000</list-flat-item>
            <list-flat-item>De kosten van lijkbezorging tot maximaal €&nbsp;5.000</list-flat-item>
        </list-flat>
        <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
    </cyno-tab>
    <cyno-tab tabTitle="Eigen risico">
        <h3>Eigen risico</h3>
        <p class="no-brake">€&nbsp;0</p>
        <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
    </cyno-tab>
</cyno-tabset>

<ng-template #voorwaarden>
    <!-- prettier-ignore -->
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsMotorInsurance"
                      pdfLinkTitle="Voorwaarden Motorverzekering">in onze voorwaarden</ins-pdf-link>.
    </p>
</ng-template>
